<script setup lang="ts">
const props = defineProps<{
  color: string;
}>();
</script>
<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="none"
  >
    <path
      d="M2 5C2 3.89543 2.89543 3 4 3H19.2C20.3046 3 21.2 3.89543 21.2 5V6.6H2V5Z"
      :fill="color"
    />
    <path
      d="M2 7.7998H21.2V18.9998C21.2 20.1044 20.3046 20.9998 19.2 20.9998H4C2.89543 20.9998 2 20.1044 2 18.9998V7.7998Z"
      :fill="color"
    />
    <circle cx="21.5" cy="4.5" r="2.5" fill="#BC3493" />
  </svg>
</template>
